import axios from 'axios'
import { GetBaseUrl } from '@/utils/ConfigHelper'
import Response from '../../../Common/Response'
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'

/**
 * Cafe24 회원이 결제한 데이터를 blobUrl 형태로 가져오는 요청
 * startTime, endTime이 없을 경우 기본 7일로 데이터를 가져옴s
 * @param {string} adminToken required
 * @param {Date | null} startTime 
 * @param {Date | null} endTime 
 * @param {Number | null} dateType 
 * @returns
 */
const DownloadCafe24Data = async (
    adminToken,
    startTime = null,
    endTime = null,
    dateType = null
) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/payment/xlsx/cafe24`

        if (dateType === 6) {
            startTime.setHours(9, 0, 0, 0)
            endTime.setDate(endTime.getDate() + 1)
            endTime.setMilliseconds(endTime.getMilliseconds() - 1)
        }

        const params = {
            start_time: startTime,
            end_time: endTime,
            date_type: dateType
        }
        const config = {
            params,
            headers: { Authorization: `Bearer ${adminToken}` },
            responseType: 'blob'
        }

        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const data = response.data
        return new Response(result, data)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardSignUpData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/signup/diff`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardSignupChartData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/signup/device`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardSignupFlowData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/signup/income`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardSingupCountryData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/signup/country`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardSignupDeviceData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/signup/device`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  start_time: string,
 *  selectedCountryMenuKey: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardSignupExcelData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/signup/xlsx?date_type=6&start_time=${data.startDate.toISOString()}&end_time=${new Date().toISOString().substr(0, 10)}T23:59:59.999Z&country=${data.selectedCountryMenuKey}`
        const config = { headers: { Authorization: `Bearer ${adminToken}` }, responseType: 'blob' }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardRenderingData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/rendering/diff`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardRenderingFlowData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/rendering/income`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardRenderingCountryData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/rendering/country`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardRenderingDeviceData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/rendering/device`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardRenderingPaymentData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/rendering/paid`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
* @param adminToken
* @param {{
*  date_type: number,
*  start_time: string,
*  end_time: string,
*  raw_data_date_type: number,
*  raw_data_start_time: string,
*  raw_data_end_time: string,
*  country: string
* }} data
* @return {Promise<Response>}
*/
const GetDashboardRenderingExcelData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/rendering/xlsx`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            raw_data_date_type: data.raw_data_date_type,
            raw_data_start_time: data.raw_data_start_time,
            raw_data_end_time: data.raw_data_end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` }, responseType: 'blob' }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardPaymentData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/payment/diff`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardPaymentFlowData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/payment/income`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardPaymentCountryData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/payment/country`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}


/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardPaymentDeviceData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/payment/device`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardPaymentPGData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/payment/pg-type`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  start_time: string,
 *  selectedCountryMenuKey: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardPaymentExcelData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/payment/xlsx?date_type=6&start_time=${data.startDate.toISOString()}&end_time=${new Date().toISOString().substr(0, 10)}T23:59:59.999Z&country=${data.selectedCountryMenuKey}`
        const config = { headers: { Authorization: `Bearer ${adminToken}` }, responseType: 'blob' }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardGalleryData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/gallery/diff`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardGalleryChartData = async (adminToken, data = {}) => {
   try {
       const url = `${GetBaseUrl()}/apis/admin/dashboard/gallery/device`
       const params = {
           date_type: data.date_type,
           start_time: data.start_time,
           end_time: data.end_time,
           country: data.country
       }
       const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
       const response = await axios.get(url, config)
       const result = (response.status === 200)
       const resultData = response.data.data

       return new Response(result, resultData)
   } catch (e) {
       const publicErrorCode = GetPublicErrorCode(e)
       switch (publicErrorCode) {
           case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
               return new Response(false, publicErrorCode)
           case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
           case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
           case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
           default:
               throw e
       }
   }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardGalleryFlowData = async (adminToken, data = {}) => {
   try {
       const url = `${GetBaseUrl()}/apis/admin/dashboard/gallery/income`
       const params = {
           date_type: data.date_type,
           start_time: data.start_time,
           end_time: data.end_time,
           country: data.country
       }
       const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
       const response = await axios.get(url, config)
       const result = (response.status === 200)
       const resultData = response.data.data

       return new Response(result, resultData)
   } catch (e) {
       const publicErrorCode = GetPublicErrorCode(e)
       switch (publicErrorCode) {
           case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
               return new Response(false, publicErrorCode)
           case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
           case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
           case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
           default:
               throw e
       }
   }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardGalleryCountryData = async (adminToken, data = {}) => {
  try {
      const url = `${GetBaseUrl()}/apis/admin/dashboard/gallery/country`
      const params = {
          date_type: data.date_type,
          start_time: data.start_time,
          end_time: data.end_time,
          country: data.country
      }
      const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
      const response = await axios.get(url, config)
      const result = (response.status === 200)
      const resultData = response.data.data

      return new Response(result, resultData)
  } catch (e) {
      const publicErrorCode = GetPublicErrorCode(e)
      switch (publicErrorCode) {
          case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
              return new Response(false, publicErrorCode)
          case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
          case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
          case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
          default:
              throw e
      }
  }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardGalleryDeviceData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/gallery/device`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data
        
        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardGalleryTemplateData = async (adminToken, data = {}) => {
   try {
       const url = `${GetBaseUrl()}/apis/admin/dashboard/gallery/template-name`
       const params = {
           date_type: data.date_type,
           start_time: data.start_time,
           end_time: data.end_time,
           country: data.country
       }
       const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
       const response = await axios.get(url, config)
       const result = (response.status === 200)
       const resultData = response.data.data
       
       return new Response(result, resultData)
   } catch (e) {
       const publicErrorCode = GetPublicErrorCode(e)
       switch (publicErrorCode) {
           case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
               return new Response(false, publicErrorCode)
           case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
           case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
           case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
           default:
               throw e
       }
   }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardGalleryCategoryData = async (adminToken, data = {}) => {
  try {
      const url = `${GetBaseUrl()}/apis/admin/dashboard/gallery/template-category`
      const params = {
          date_type: data.date_type,
          start_time: data.start_time,
          end_time: data.end_time,
          country: data.country
      }
      const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
      const response = await axios.get(url, config)
      const result = (response.status === 200)
      const resultData = response.data.data
      
      return new Response(result, resultData)
  } catch (e) {
      const publicErrorCode = GetPublicErrorCode(e)
      switch (publicErrorCode) {
          case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
              return new Response(false, publicErrorCode)
          case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
          case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
          case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
          default:
              throw e
      }
  }
}

/**
* @param adminToken
* @param {{
*  date_type: number,
*  start_time: string,
*  end_time: string,
*  raw_data_date_type: number,
*  raw_data_start_time: string,
*  raw_data_end_time: string,
*  country: string
* }} data
* @return {Promise<Response>}
*/
    const GetDashboardGalleryExcelData = async (adminToken, data = {}) => {
        try {
            const url = `${GetBaseUrl()}/apis/admin/dashboard/gallery/xlsx`
            const params = {
                date_type: data.date_type,
                start_time: data.start_time,
                end_time: data.end_time,
                raw_data_date_type: data.raw_data_date_type,
                raw_data_start_time: data.raw_data_start_time,
                raw_data_end_time: data.raw_data_end_time,
                country: data.country
            }
            const config = { params, headers: { Authorization: `Bearer ${adminToken}` }, responseType: 'blob' }
            const response = await axios.get(url, config)
            const result = (response.status === 200)
            const resultData = response.data
    
            return new Response(result, resultData)
        } catch (e) {
            const publicErrorCode = GetPublicErrorCode(e)
            switch (publicErrorCode) {
                case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
                case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
                default:
                    throw e
            }
        }
    }

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardConversionData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/conversion/diff`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardConversionChartData = async (adminToken, data = {}) => {
   try {
       const url = `${GetBaseUrl()}/apis/admin/dashboard/conversion/device`
       const params = {
           date_type: data.date_type,
           start_time: data.start_time,
           end_time: data.end_time,
           country: data.country
       }
       const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
       const response = await axios.get(url, config)
       const result = (response.status === 200)
       const resultData = response.data.data

       return new Response(result, resultData)
   } catch (e) {
       const publicErrorCode = GetPublicErrorCode(e)
       switch (publicErrorCode) {
           case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
               return new Response(false, publicErrorCode)
           case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
           case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
           case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
           default:
               throw e
       }
   }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardConversionFlowData = async (adminToken, data = {}) => {
   try {
       const url = `${GetBaseUrl()}/apis/admin/dashboard/conversion/income`
       const params = {
           date_type: data.date_type,
           start_time: data.start_time,
           end_time: data.end_time,
           country: data.country
       }
       const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
       const response = await axios.get(url, config)
       const result = (response.status === 200)
       const resultData = response.data.data

       return new Response(result, resultData)
   } catch (e) {
       const publicErrorCode = GetPublicErrorCode(e)
       switch (publicErrorCode) {
           case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
               return new Response(false, publicErrorCode)
           case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
           case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
           case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
           default:
               throw e
       }
   }
}

/**
 * @param adminToken
 * @param {{
*  date_type: number,
*  start_time: string,
*  end_time: string,
*  country: string
* }} data
* @return {Promise<Response>}
*/
const GetDashboardConversionCountryData = async (adminToken, data = {}) => {
  try {
      const url = `${GetBaseUrl()}/apis/admin/dashboard/conversion/country`
      const params = {
          date_type: data.date_type,
          start_time: data.start_time,
          end_time: data.end_time,
          country: data.country
      }
      const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
      const response = await axios.get(url, config)
      const result = (response.status === 200)
      const resultData = response.data.data

      return new Response(result, resultData)
  } catch (e) {
      const publicErrorCode = GetPublicErrorCode(e)
      switch (publicErrorCode) {
          case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
              return new Response(false, publicErrorCode)
          case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
          case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
          case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
          default:
              throw e
      }
  }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardConversionDeviceData = async (adminToken, data = {}) => {
  try {
      const url = `${GetBaseUrl()}/apis/admin/dashboard/conversion/device`
      const params = {
          date_type: data.date_type,
          start_time: data.start_time,
          end_time: data.end_time,
          country: data.country
      }
      const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
      const response = await axios.get(url, config)
      const result = (response.status === 200)
      const resultData = response.data.data

      return new Response(result, resultData)
  } catch (e) {
      const publicErrorCode = GetPublicErrorCode(e)
      switch (publicErrorCode) {
          case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
              return new Response(false, publicErrorCode)
          case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
          case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
          case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
          default:
              throw e
      }
  }
}

/**
 * @param adminToken
 * @param {{
 *  start_time: string,
 *  selectedCountryMenuKey: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardConversionExcelData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/conversion/xlsx?date_type=6&start_time=${data.startDate.toISOString()}&end_time=${new Date().toISOString().substr(0, 10)}T23:59:59.999Z&country=${data.selectedCountryMenuKey}`
        const config = { headers: { Authorization: `Bearer ${adminToken}` }, responseType: 'blob' }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardRenderingChartData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/rendering/paid`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardTemplateChartData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/template/name-based?is_free=${data.is_free}`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardTemplateCategoryData = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/template/category-based?is_free=${data.is_free}`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {{
 *  start_time: string,
 *  selectedCountryMenuKey: string
 * }} data
 * @return {Promise<Response>}
 */
const GetDashboardTemplateExcelData = async (adminToken, data = {}) => {
    try {
        const { dateType, startTime, endTime, selectedCountryMenuKey } = data
        const url = `${GetBaseUrl()}/apis/admin/dashboard/template/rank-xlsx`
        const config = { 
            params: {
                date_type: dateType,
                start_time: startTime,
                end_time: endTime,
                country: selectedCountryMenuKey
            },
            headers: { Authorization: `Bearer ${adminToken}` }, 
            responseType: 'blob' 
        }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param adminToken
 * @param {string} dataType
 * @param {{
 *  date_type: number,
 *  start_time: string,
 *  end_time: string,
 *  country: string
 * }} data
 * @return {Promise<Response>}
 */
const _GetDashboardCreditDataGeneric = async (adminToken, dataType, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/dashboard/credit/${dataType}`
        const params = {
            date_type: data.date_type,
            start_time: data.start_time,
            end_time: data.end_time,
            country: data.country
        }
        const config = { params, headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

const GetDashboardCreditData = async (adminToken, data = {}) => _GetDashboardCreditDataGeneric(adminToken, 'diff', data)
const GetDashboardCreditProductData = async (adminToken, data = {}) => _GetDashboardCreditDataGeneric(adminToken, 'product', data)
const GetDashboardCreditFlowData = async (adminToken, data = {}) => _GetDashboardCreditDataGeneric(adminToken, 'income', data)
const GetDashboardCreditCountryData = async (adminToken, data = {}) => _GetDashboardCreditDataGeneric(adminToken, 'country', data)
const GetDashboardCreditDeviceData = async (adminToken, data = {}) => _GetDashboardCreditDataGeneric(adminToken, 'device', data)

export default {
    DownloadCafe24Data,

    GetDashboardSignUpData,
    GetDashboardSignupChartData,
    GetDashboardSignupFlowData,
    GetDashboardSingupCountryData,
    GetDashboardSignupDeviceData,
    GetDashboardSignupExcelData,

    GetDashboardRenderingData,
    GetDashboardRenderingChartData,
    GetDashboardRenderingFlowData,
    GetDashboardRenderingCountryData,
    GetDashboardRenderingDeviceData,
    GetDashboardRenderingPaymentData,
    GetDashboardRenderingExcelData,

    GetDashboardPaymentData,
    GetDashboardPaymentFlowData,
    GetDashboardPaymentCountryData,
    GetDashboardPaymentDeviceData,
    GetDashboardPaymentPGData,
    GetDashboardPaymentExcelData,

    GetDashboardGalleryData,
    GetDashboardGalleryChartData,
    GetDashboardGalleryFlowData,
    GetDashboardGalleryCountryData,
    GetDashboardGalleryDeviceData,
    GetDashboardGalleryTemplateData,
    GetDashboardGalleryCategoryData,
    GetDashboardGalleryExcelData,

    GetDashboardConversionData,
    GetDashboardConversionChartData,
    GetDashboardConversionFlowData,
    GetDashboardConversionCountryData,
    GetDashboardConversionDeviceData,
    GetDashboardConversionExcelData,

    GetDashboardTemplateChartData,
    GetDashboardTemplateCategoryData,
    GetDashboardTemplateExcelData,

    GetDashboardCreditData,
    GetDashboardCreditProductData,
    GetDashboardCreditFlowData,
    GetDashboardCreditCountryData,
    GetDashboardCreditDeviceData,
}